<template>
  <div class="location-page">
    <LayoutLanding>
      <!-- HERO -->
      <section class="location-hero">
        <div class="overlay-location">
          <h1>{{ heroTitle }}</h1>
          <p class="location-subtitle">{{ heroSubtitle }}</p>
        </div>
      </section>

      <div class="location-container">

        <div class="location-gallery">
          <img v-for="(image, index) in imagePaths" :key="index" :src="image" alt="Galería SPARK81" />
        </div>
        <div class="location-row">
          <!-- Columna Izquierda -->
          <div class="location-col-left">
            <h2>{{ sectionTitle }}</h2>
            <p>{{ sectionDescription }}</p>
            <p>{{ additionalInfo }}</p>

            <h2>SALAS DISPONIBLES</h2>
            <div class="gallery-rooms">

              <img v-for="(image, index) in filteredRoomImages" :key="index" :src="image" alt="Sala SPARK81" />
            </div>
            <section>
              <h2>Precios</h2>

              <div v-if="pricingType === 'A'">
                <p>Precios por participante con las opciones de 3 salas (1h) y 5 salas (1h 40min)</p>
                <table class="orange-table table-desktop">
                  <thead>
                    <tr>
                      <th v-for="(title, index) in pricingHeaders.desktop" :key="'desktop-' + index" v-html="title"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="key in participantKeysList" :key="'fila-' + key">
                      <td>{{ participantKeys[key] }}</td>
                      <td v-html="getPrice(pricing.entreSemana?.['3salas'], key)"></td>
                      <td v-html="getPrice(pricing.entreSemana?.['5salas'], key)"></td>
                      <td v-html="getPrice(pricing.findeFestivos?.['3creditos'], key)"></td>
                      <td v-html="getPrice(pricing.findeFestivos?.['5creditos'], key)"></td>
                    </tr>
                  </tbody>
                </table>

                <!-- ✅ Mobile: dos tablas separadas -->
                <div class="table-mobile">
                  <p><strong>{{ pricingHeaders?.mobile?.titlesemana }}</strong></p>
                  <table class="orange-table">
                    <thead>
                      <tr>
                        <th v-for="(title, index) in pricingHeaders.mobile.entreSemana" :key="'mobile-lv-' + index" v-html="title"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="key in participantKeysList" :key="'mobile-lv-' + key">
                        <td>{{ participantKeys[key] }}</td>
                        <td v-html="getPrice(pricing.entreSemana?.['3salas'], key)"></td>
                        <td v-html="getPrice(pricing.entreSemana?.['5salas'], key)"></td>
                      </tr>
                    </tbody>
                  </table>

                  <p><strong>{{ pricingHeaders?.mobile?.titlefinde }}</strong></p>
                  <table class="orange-table">
                    <thead>
                      <tr>
                        <th v-for="(title, index) in pricingHeaders.mobile.findeFestivos" :key="'mobile-fd-' + index" v-html="title"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="key in participantKeysList" :key="'mobile-fd-' + key">
                        <td>{{ participantKeys[key] }}</td>
                        <td v-html="getPrice(pricing.findeFestivos?.['3creditos'], key)"></td>
                        <td v-html="getPrice(pricing.findeFestivos?.['5creditos'], key)"></td>
                      </tr>
                    </tbody>
                  </table>
                </div>



                <!-- 🎉 PACK CUMPLE -->
                <h3 style="margin-top: 2rem;">
                  <span v-if="pricing.cumpleanos.finde > 0">Pack cumpleaños</span>
                  <span v-else>Pack cumpleaños (De martes a jueves)</span>

                </h3>
                <p v-if="cumpleanosDescription" v-html="cumpleanosDescription" class="mb-4"></p>

                <table v-if="pricing.cumpleanos?.menus" class="orange-table">
                  <thead>
                    <tr>
                      <th>Opción</th>
                      <th>Mar-Jue</th>
                      <th
                      v-if="pricing.cumpleanos.finde > 0"
                      >
                      Viernes / Finde / festivos</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(menu, key) in pricing.cumpleanos.menus" :key="key">
                      <td>{{ key.charAt(0).toUpperCase() + key.slice(1) }}</td>
                      <td>{{ menu.entreSemana }} €</td>
                      <td
                      v-if="pricing.cumpleanos.finde > 0"
                      >{{ menu.finde }} €</td>
                    </tr>
                  </tbody>
                </table>

                <!-- 🏢 EVENTO PRIVADO -->
                <h3 style="margin-top: 2rem;">Evento privado</h3>
                <p v-if="eventoPrivadoDescription" v-html="eventoPrivadoDescription" class="mb-4"></p>
                <table v-if="pricing.eventoPrivado" class="orange-table">
                  <thead>
                    <tr>
                      <th>Opción</th>
                      <th>Precio por participante (sin IVA)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="pricing.eventoPrivado['2h']">
                      <td>2 horas</td>
                      <td>{{ pricing.eventoPrivado['2h'].precio }} €</td>
                    </tr>
                    <tr v-if="pricing.eventoPrivado.horaExtra">
                      <td>Hora extra</td>
                      <td>{{ pricing.eventoPrivado.horaExtra.precio }} €</td>

                    </tr>
                    <tr v-if="pricing.eventoPrivado.mediaManana">
                      <td>Media jornada mañana ({{ pricing.eventoPrivado.mediaManana.duracion }})</td>
                      <td>{{ pricing.eventoPrivado.mediaManana.precio }} €</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- 🟡 Versió B -->
              <div v-else-if="pricingType === 'B'">
                <p>Se muestran los precios por participante según el tamaño del grupo.</p>
                <table class="orange-table">
                  <thead>
                    <tr>
                      <th>Jugadores</th>
                      <th>Precio por persona</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, i) in pricing" :key="i">
                      <td>{{ item.nom }}</td>
                      <td>{{ item.preu }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div v-else>
                <p>Precios no disponibles.</p>
              </div>
            </section>
            <h2>EVENTOS</h2>
            <p>{{ eventsDescription }}</p>
            <div class="main-button">
              <a href="#" @click.prevent="() => {$router.push('/booking')}">RESERVA TU PARTIDA EN {{ heroTitle }}</a>
            </div>
          </div>

          <!-- Columna Derecha -->
          <div class="location-col-right">
            <div class="location-col-right2">
              <div class="col-right-text">
              <p v-if="address"><i class="fa fa-map-marker-alt"></i> {{ address }}</p>
              <p v-if="locationLink"><a :href="locationLink" target="_blank"><i class="fa fa-location-arrow"></i> Cómo llegar</a></p><p v-if="email"><i class="fa fa-envelope"></i> <a :href="'mailto:' + email">{{ email }}</a></p>
              <p v-if="phone"><i class="fa fa-phone"></i> <a :href="'tel:' + phone">{{ phone }}</a></p>
              <br v-if="busLines || metroStation || parkingInfo">

              <p v-if="busLines || busStop"><i class="fa fa-bus"></i> Autobús: {{ busLines }} <span v-if="busStop">(Parada: {{ busStop }})</span></p>
              <p v-if="metroStation"><i class="fa fa-subway"></i> Metro: {{ metroStation }}</p>
              <p v-if="trainStation"><i class="fa fa-train"></i> Tren: {{ trainStation }}</p>
              <p v-if="tramStation"><i class="fa fa-subway"></i> Tram: {{ tramStation }}</p>
              <p v-if="parkingInfo"><i class="fa fa-car"></i> Parking: {{ parkingInfo }}</p>


              <br>
              <p><i class="fa fa-clock"></i> Horario:</p>
              <p v-if="mondaySchedule">Lunes: {{ mondaySchedule }}</p>
              <p v-if="tuesdaythursdaySchedule">Martes - Jueves: {{ tuesdaythursdaySchedule }}</p>
              <p v-if="fridaySchedule">Viernes: {{ fridaySchedule }}</p>
              <p v-if="saturdaySchedule">Sábado: {{ saturdaySchedule }}</p>
              <p v-if="sundaySchedule">Domingo: {{ sundaySchedule }}</p>

              <br v-if="instagram || tiktok">

              <p v-if="instagram"><a :href="instagram" target="_blank"><i class="fab fa-instagram"></i> Instagram</a></p>
              <p v-if="tiktok"><a :href="tiktok" target="_blank"><i class="fab fa-tiktok"></i> TikTok</a></p>
            </div>
            </div>

          </div>
        </div>
      </div>
    </LayoutLanding>
  </div>
</template>

<script>
import LayoutLanding from "@/components/LayoutLanding.vue";
import { computed } from 'vue';

export default {
  components: {
    LayoutLanding,
  },
  props: {
    heroTitle: String,
    heroSubtitle: String,
    sectionTitle: String,
    sectionDescription: String,
    additionalInfo: String,
    eventsDescription: String,
    address: String,
    locationLink: String,
    email: String,
    phone: String,
    busLines: String,
    busStop: String,
    metroStation: String,
    trainStation: String,
    tramStation: String,
    parkingInfo: String,
    mondaySchedule: String,
    tuesdaythursdaySchedule: String,
    fridaySchedule: String,
    saturdaySchedule: String,
    sundaySchedule: String,
    images: Array,
    rooms: String,
    instagram: String,
    tiktok: String,
    pricingType: String,
    pricing: Object,
    pricingHeaders: Object,
    cumpleanosDescription: String,
    eventoPrivadoDescription: String,
  },
  data() {
    return {
      participantKeys: {
        "2": "2",
        "3": "3",
        "4": "4",
        "5": "5",
        "6+": "6 o más"
      },
      participantKeysList: ["2", "3", "4", "5", "6+"]
    };
  },
  methods: {
    getPrice(table, key) {
    if (!table || !(key in table)) return "-";
    const value = table[key];
    if (typeof value === "object" && value.old && value.new) {
      return `<span class='strike'>${value.old} €</span> <span>${value.new} €</span>`;
    }
    return `${value} €`;
  }

  },
  computed: {
    imagePaths() {
      console.log(this.images)
      return this.images.map(image => (`/images/${image}`));
    },
    filteredRoomImages() {
      const predefinedImages = {
        dianas: new URL("/src/assets/images/Nombres-salas/Dianas.png", import.meta.url).href,
        botones: new URL("/src/assets/images/Nombres-salas/Botones.png", import.meta.url).href,
        mosaico: new URL("/src/assets/images/Nombres-salas/Mosaico.png", import.meta.url).href,
        jungla: new URL("/src/assets/images/Nombres-salas/Jungla.png", import.meta.url).href,
        gaming: new URL("/src/assets/images/Nombres-salas/Gaming.png", import.meta.url).href,
        radar: new URL("/src/assets/images/Nombres-salas/Radar.png", import.meta.url).href,
        mosaicox2: new URL("/src/assets/images/Nombres-salas/Mosaicox2.png", import.meta.url).href
      };

      return this.rooms.split(',').map(room => predefinedImages[room.trim()]).filter(image => image);
    }
  },





};
</script>